import api from "./base";

export interface LL97SubmissionItem {
  id: string;
  building: {
    id: string;
    name: string;
    companyName: string;
  };
  status: number;
  article: string;
  pathway: string;
  paid: boolean;
  attestationObj: {
    status: number;
    file: {
      name: string;
    };
  };
}

export interface LL88SubmissionItem {
  id: string;
  building: {
    id: string;
    name: string;
    companyName: string;
  };
  status: number;
  paid: boolean;
  attestationObj: {
    status: number;
    file: {
      name: string;
    };
  };
}

export interface LL97CBLDisputeItem {
  id: string;
  ll97Submissions: LL97SubmissionItem[];
  files: any[];
}

export interface StaffSubmissionsResponse {
  ll97Submissions: LL97SubmissionItem[];
  ll88Submissions: LL88SubmissionItem[];
  cblDisputes: LL97CBLDisputeItem[];
  extensionRequests: LL97SubmissionItem[];
}

export const fetchStaffSubmissions = async (
  filters: any,
): Promise<StaffSubmissionsResponse> => {
  const initFilters = filters ? { ...filters } : {};
  if (initFilters.q) {
    initFilters.type = "all";
  }
  const response = await api.get("/staff/submissions", { params: initFilters });
  return response.data;
};

/**
 * Fetches a specific LL97 submission for staff view
 */
export const fetchStaffLL97Submission = async (submissionId: string) => {
  const response = await api.get(`/staff/submissions/ll97/${submissionId}/`);
  return response.data;
};

/**
 * Fetches a specific LL88 submission for staff view
 */
export const fetchStaffLL88Submission = async (submissionId: string) => {
  const response = await api.get(`/staff/submissions/ll88/${submissionId}/`);
  return response.data;
};

export const fetchRdpSubmissions = async () => {
  const response = await api.get(`/rdp/submissions/`);
  return response.data;
};

export const fetchRdpLL97Submission = async (submissionId: string) => {
  const response = await api.get(`/rdp/submissions/ll97/${submissionId}/`);
  return response.data;
};

export const fetchRdpLL88Submission = async (submissionId: string) => {
  const response = await api.get(`/rdp/submissions/ll88/${submissionId}/`);
  return response.data;
};

export const saveDOBPaymentTransactionId = (dobPayment: any) =>
  api.post(`/staff/submissions/dob-payment/${dobPayment.id}/`, {
    transactionId: dobPayment.dobPaymentTransactionId,
    reimbursementStatus: dobPayment.reimbursementStatus,
    amount: dobPayment.amount,
  });
export const fetchLL97CBLDispute = (disputeId: string) =>
  api.get(`/audits/cbl_disputes/${disputeId}/`).then((res) => res.data);

export const adjustCblDisputeSubmissions = (
  ll97SubmissionId: string,
  cblDisputeId: string,
  action: "add" | "remove",
) =>
  api.post("/staff/submissions/cbl-dispute-submission-change/", {
    ll97_submission_id: ll97SubmissionId,
    cbl_dispute_id: cblDisputeId,
    action,
  });
